/**
 * ProposalDetailPresenter
 * --
 */
import React from 'react';

const ProposalDetailPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <div>
      <p>ProposalDetailPresenter</p>
    </div>
  );
};

export default ProposalDetailPresenter;
